import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import type { InsightInternalCtaBlock } from '../../types';
import { gradientPillCss } from '../../../../styles/gradientPill';

const Wrap = styled.aside`
  max-width: 46rem;
  margin: 0 auto;
  padding: 1.5rem;
  border-radius: 28px;
  border: none;
  background: rgba(255, 255, 255, 0.48);
  box-shadow: 0 18px 38px rgba(8, 14, 24, 0.08);
  display: grid;
  gap: 0.9rem;
`;

const Eyebrow = styled.span<{ $accent: string }>`
  font-size: 0.76rem;
  line-height: 1;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  font-weight: 900;
  color: ${({ $accent }) => $accent};
`;

const Title = styled.h3`
  margin: 0;
  font-family: var(--font-serif);
  font-size: clamp(1.5rem, 2.8vw, 2rem);
  line-height: 1.02;
  letter-spacing: -0.03em;
  color: #132235;
`;

const Text = styled.p`
  margin: 0;
  color: rgba(20, 34, 53, 0.74);
  font-size: 1rem;
  line-height: 1.72;
`;

const Cta = styled(Link)`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  text-decoration: none;
  ${gradientPillCss};
`;

type InternalCtaBlockProps = {
  block: InsightInternalCtaBlock;
  accent: string;
};

export default function InternalCtaBlock({ block, accent }: InternalCtaBlockProps) {
  return (
    <Wrap>
      {block.eyebrow ? <Eyebrow $accent={accent}>{block.eyebrow}</Eyebrow> : null}
      {block.title ? <Title>{block.title}</Title> : null}
      {block.text ? <Text>{block.text}</Text> : null}
      <Cta to={block.to}>
        <span>{block.label}</span>
        <ArrowRight size={16} aria-hidden="true" />
      </Cta>
    </Wrap>
  );
}
